<template>
  <div class="shared">
    <div class="shared__body">
      <div class="shared__title">Siga-nos nas redes sociais</div>
      <div class="shared__button-container">
        <a
          class="share__button facebook"
          href="https://www.facebook.com/sharer/sharer.php?u=https://makeawish.pt/"
          target="_blank"
        >
          <img src="/images/buttons/facebook.svg" alt="Facebook" />
        </a>
        <a
          class="share__button instagram"
          href="https://www.instagram.com/makeawishportugal/"
          target="_blank"
        >
          <img src="/images/buttons/instagram.svg" alt="Instagram" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shared-buttons",
  components: {}
};
</script>

<style scoped lang="scss">
.shared {
  &__body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 62px;

    @media (min-width: $breakpoint-lg) {
      flex-direction: row;
      margin-top: 130px;
    }
  }

  &__title {
    font-family: "droid_serifbold";
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: $color-make-a-wish-blue;

    @media (min-width: $breakpoint-lg) {
      margin-right: 32px;
      font-size: 38px;
      line-height: 44px;
    }
  }

  &__button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;

    @media (min-width: $breakpoint-lg) {
      margin-top: 0;
    }

    :not(:first-child) {
      margin-left: 25px;
    }
  }

  .share__button {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    img {
      width: 48px;
      height: 48px;
      object-fit: contain;
    }
  }
}
</style>
